// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@kubb/plugin-client/clients/axios";
import type { GetCurrentUserUsersMeGetQueryResponse } from "../models/usersController/GetCurrentUserUsersMeGet.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";

function getGetCurrentUserUsersMeGetUrl() {
  const res = { method: "GET", url: `/users/me` as const };
  return res;
}

/**
 * @description Get current authenticated user profile.
 * @summary Get Current User
 * {@link /users/me}
 */
export async function getCurrentUserUsersMeGet(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetCurrentUserUsersMeGetQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: getGetCurrentUserUsersMeGetUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
